angular.module('SpidApp')

angular.module('SpidApp')

.factory('GenericSyncServiceFactory', ['$http', 'SyncConfig', 'Chunker', '$q', function ($http, SyncConfig, Chunker, $q) {
  var GenericSyncServiceFactory = function (params) {
    var nodeUrl           = SyncConfig.Node.getURLFor(params.nodeFetchUrl)
    var nodePushUrl       = SyncConfig.Node.getURLFor(params.nodePushUrl)
    var nodeAuthorization = SyncConfig.Node.Authorization

    var distantUrl           = SyncConfig.Distant.getURLFor(params.distantUrl)
    var distantAuthorization = SyncConfig.Distant.Authorization

    var Service = {
      Node: {
        getAllUnsync: function (lastSyncIsoDate) {
          if (!lastSyncIsoDate) {
            throw 'GenericSyncServiceFactory::Node::getAllUnsync() - Missing parameters'
          }

          var req = { method: 'GET', url: nodeUrl, headers: { 'Authorization': nodeAuthorization } }

          return $http(req).then(function (response) {
            return response.data
          }).then(function (users) {
            return _.filter(users, function (user) {
              return moment(user.updated_at).isAfter(moment(lastSyncIsoDate), 'second')
            })
          })
        },

        pushAll: function (elems) {
          var chunked = Chunker.inConstantSizeChunks(elems, SyncConfig.config.chunkLength)
          var p = $q(function (r) {r()})

          var pool = []
          for(var i = 0 ; i < chunked.length ; i++) {
            var data = chunked[i]
            var req = { method: 'POST', url: nodePushUrl, headers: { 'Authorization': nodeAuthorization }, data: data }
            pool.push($http(req))
          }

          return p.then(function () {
            return $q.all(pool)
          }).then(function () {
            return {generic: 'OK'}
          })
        }
      },
      Distant: {
        getAllUnsync: function () {
          var req = { method: 'GET', url: distantUrl, headers: { 'Authorization': distantAuthorization } }

          return $http(req).then(function (response) {
            return response.data
          })
        },
          pushAll: function (users) {
              var chunked = Chunker.inConstantSizeChunks(users, SyncConfig.config.chunkLength)
              var p = $q(function (r) {r()})

              var pool = []
              for(var i = 0 ; i < chunked.length ; i++) {
                  var data = chunked[i]
                  var req = { method: 'POST', url: distantUrl, headers: { 'Authorization': distantAuthorization }, data: data }
                  pool.push($http(req))
              }

              return p.then(function () {
                  return $q.all(pool)
              }).then(function () {
                  return {generic: 'OK'}
              })
          }
      }
    }

    return Service
  }
  
  return GenericSyncServiceFactory
}])